import { render, staticRenderFns } from "./HomeMainSpVideoCard.vue?vue&type=template&id=aa89b3c6&scoped=true&"
import script from "./HomeMainSpVideoCard.vue?vue&type=script&lang=ts&"
export * from "./HomeMainSpVideoCard.vue?vue&type=script&lang=ts&"
import style0 from "./HomeMainSpVideoCard.vue?vue&type=style&index=0&id=aa89b3c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa89b3c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseImage: require('/codebuild/output/src2039654861/src/threease_lp/components/shared/Base/BaseImage.vue').default,BaseMaxWidthContainer: require('/codebuild/output/src2039654861/src/threease_lp/components/shared/Base/BaseMaxWidthContainer.vue').default})
